// ErpTable.tsx - 서버 명세 열로 그리는 범용 표 (기존 ERP 이관 화면 150개 공용).
//
// 열 이름·순서·표시 형식은 전부 서버 명세(`ErpColumn`)다. 이 컴포넌트는 판단하지
// 않는다: 숫자 열은 오른쪽 정렬 + tabular-nums, 합계 행은 `totals` 가 있을 때만.
import { THead, Table, TableScroll, Td, Th, Tr } from "@/components/Table";
import { type ErpColumn, type ErpRow, cellText, isNumeric } from "@/lib/erp";

export const ErpTable = ({
  label,
  columns,
  rows,
  totals,
  onRowClick,
  rowKey,
}: {
  label: string;
  columns: ErpColumn[];
  rows: ErpRow[];
  totals: ErpRow | null;
  /** 있으면 행 클릭으로 수정 폼을 연다 (편집 가능한 엔티티 행만) */
  onRowClick?: (row: ErpRow) => void;
  rowKey: (row: ErpRow, index: number) => string;
}) => {
  const hasTotals = totals !== null && Object.keys(totals).length > 0;
  return (
    <TableScroll>
      <Table label={label}>
        <THead>
          <tr>
            {columns.map((c) => (
              <Th key={c.key} num={isNumeric(c.type)} width={c.width ?? undefined}>
                {c.label}
                {c.unit && (
                  <span className="normal-case" style={{ color: "var(--text-quaternary)" }}>
                    {" "}
                    ({c.unit})
                  </span>
                )}
              </Th>
            ))}
          </tr>
        </THead>
        <tbody>
          {rows.map((r, i) => (
            <Tr
              key={rowKey(r, i)}
              onClick={onRowClick && typeof r.id === "string" ? () => onRowClick(r) : undefined}
            >
              {columns.map((c, ci) => (
                <Td
                  key={c.key}
                  num={isNumeric(c.type)}
                  strong={ci === 0}
                  // 긴 메모·주소는 줄바꿈 대신 말줄임 - 행 높이 36px 를 지킨다 (Table.tsx)
                  style={
                    c.type === "longtext"
                      ? { maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis" }
                      : undefined
                  }
                >
                  {cellText(c, r)}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
        {hasTotals && (
          <tfoot>
            <tr style={{ background: "var(--surface-inset)" }}>
              {columns.map((c, i) => (
                <Td key={c.key} num={isNumeric(c.type)} strong>
                  {totals && c.key in totals ? cellText(c, totals) : i === 0 ? "합계" : ""}
                </Td>
              ))}
            </tr>
          </tfoot>
        )}
      </Table>
    </TableScroll>
  );
};
